<template>
  <v-dialog
    :value="isFiltrosDialogOpen"
    max-width="700px"
    persistent
  >
    <v-card class="pa-sm-8 pa-2">
      <btn-close-dialog :handle-click="closeDialog" />

      <v-card-title class="justify-center text-h5 pt-0">
        Filtros
      </v-card-title>

      <v-card-text class="mt-5">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model.trim="filtroEmailLocale"
              dense
              outlined
              clearable
              hide-details
              validate-on-blur
              label="Buscar por e-mail do solicitante"
              placeholder="Buscar por e-mail do solicitante"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model.trim="filtroProtocoloLocale"
              dense
              outlined
              clearable
              hide-details
              validate-on-blur
              label="Buscar por protocolo"
              placeholder="Buscar por protocolo"
            />
          </v-col>

          <v-col
            v-if="isGestor"
            cols="12"
          >
            <v-autocomplete
              v-model="filtroAgenteSelecionadoLocale"
              dense
              outlined
              clearable
              hide-details
              validate-on-blur
              label="Agentes"
              item-text="agenteNome"
              item-value="agenteId"
              no-data-text="Nenhum agente disponível"
              :loading="isGetAgentesDoGestorLoading"
              :items="agentesDoGestor"
              @click="getAgentesDoGestor"
            />
          </v-col>

          <v-col
            cols="12"
            class="d-flex justify-center"
          >
            <v-btn
              class="mb-md-0 mb-3 mr-3"
              color="primary"
              outlined
              @click="closeDialog"
            >
              Cancelar
            </v-btn>

            <v-btn
              class="mb-md-0 mb-3"
              color="primary"
              @click="handleFiltrarTicketsClick"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'
import FilaService from '@/services/modules/FilaService'

export default {
  components: {
    BtnCloseDialog,
  },

  emits: ['update:is-filtros-dialog-open', 'update:filtro-email', 'update:filtro-protocolo', 'update:filtro-agente-selecionado'],

  props: {
    filaId: {
      type: Number,
      default: null,
    },
    isFiltrosDialogOpen: {
      type: Boolean,
      required: true,
    },
    isGestor: {
      type: Boolean,
      required: true,
    },
    filtrosForamAlterados: {
      type: Boolean,
      required: true,
    },
    filtrarTickets: {
      type: Function,
      required: true,
    },
  },

  setup(props, { emit }) {
    const agentesDoGestor = ref([])
    const isGetAgentesDoGestorLoading = ref(false)

    async function getAgentesDoGestor() {
      if (isGetAgentesDoGestorLoading.value || agentesDoGestor.value.length > 0) return
      try {
        isGetAgentesDoGestorLoading.value = true
        agentesDoGestor.value = await FilaService.getAgentesDoGestor(props.filaId)
      } finally {
        isGetAgentesDoGestorLoading.value = false
      }
    }

    const filtroEmailLocale = ref(null)
    const filtroProtocoloLocale = ref(null)
    const filtroAgenteSelecionadoLocale = ref(0)

    function resetFilters() {
      filtroEmailLocale.value = null
      filtroProtocoloLocale.value = null
      filtroAgenteSelecionadoLocale.value = 0
    }
    watchEffect(() => { if (!props.filtrosForamAlterados) { resetFilters() } })

    function closeDialog() {
      emit('update:is-filtros-dialog-open', false)
    }
    function resetFiltersAndCloseDialog() {
      resetFilters()
      closeDialog()
    }
    async function handleFiltrarTicketsClick() {
      await new Promise(resolve => {
        emit('update:filtro-email', filtroEmailLocale.value)
        emit('update:filtro-protocolo', filtroProtocoloLocale.value)
        emit('update:filtro-agente-selecionado', filtroAgenteSelecionadoLocale.value)
        resolve()
      })
      props.filtrarTickets()
      closeDialog()
    }

    return {
      agentesDoGestor,
      isGetAgentesDoGestorLoading,
      getAgentesDoGestor,
      filtroEmailLocale,
      filtroProtocoloLocale,
      filtroAgenteSelecionadoLocale,
      closeDialog,
      resetFiltersAndCloseDialog,
      handleFiltrarTicketsClick,
    }
  },
}
</script>
